  // "Newest First" leads because it is the default sort — the list the buyer
  // lands on should be the one highlighted in the picker.
  export const sortOptions = [
    { value: "newest", label: "Newest First" },
    { value: "price-low", label: "Price: Low to High" },
    { value: "price-high", label: "Price: High to Low" },
    { value: "curator", label: "Curator's pick" },
  ];